/* eslint-disable import/no-named-as-default-member */
/* eslint-disable @typescript-eslint/no-explicit-any */

import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import { useState, useEffect } from 'react'

import { ErrorProps } from './common'
import { FormEvent as FormEventApi } from '../API'
import { formEventBySlug } from '../api/queries'
import { fetchQuery } from '../utils/ApiUtils'

dayjs.extend(utc)
dayjs.extend(timezone)

type FormEvent = Omit<Exclude<FormEventApi, null>, '__typename'>

// interface ATDInfo {
//   label?: string
//   text?: string
// }

interface Props {
  slug: string | null | undefined
}
const useFormEventDetails = ({ slug }: Props) => {
  const [event, setEvent] = useState<FormEvent>()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<ErrorProps>()

  useEffect(() => {
    let didCancel = false
    const fetchData = async () => {
      if (didCancel) return
      setLoading(true)

      try {
        const { items } = (await fetchQuery(
          'formEventBySlug',
          formEventBySlug,
          {
            slug,
            filter: {
              registrationCutOff: {
                gt: dayjs().tz('Asia/Manila'),
              },
            },
          },
        )) as unknown as { items: FormEvent[] }

        if (items.length > 0) {
          const item = items[0]
          item.tshirtFees = JSON.parse(JSON.parse(item.tshirtFees))

          const atdInfoParsed = JSON.parse(JSON.parse(item.atdInfo))
          item.atdInfo = {
            label: `Authority to deduct form for payment through salary deduction`,
            text: `I, the undersigned employee hereby authorize the employer paymaster to make deductions from my salary as payment for the t-shirt that I will use for ${
              item.name
            }. Total amount of payment shall be deductible in 2 quincenas starting from ${dayjs(
              item.registrationCutOff,
            )
              .add(1, 'month')
              .tz('Asia/Manila')
              .format('MMMM 15, YYYY')}.`,
            ...atdInfoParsed,
          }
          setEvent(item)
        }
      } catch (e) {
        console.log(e)
        setError({
          title: 'Fail to load event',
          message: '',
        })
      }
      setLoading(false)
    }

    fetchData()

    return () => {
      didCancel = true
    }
  }, [slug])

  return {
    event,
    apiLoading: loading,
    apiError: error,
  }
}

export default useFormEventDetails
